export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9739.23ef8e40.jpg";